export const splitEmployeeNames = (value?: string | null): string[] =>
  String(value || "")
    .split(",")
    .map((name) => name.trim())
    .filter(Boolean);

export const joinEmployeeNames = (names: string[]): string =>
  names.map((name) => name.trim()).filter(Boolean).join(", ");

/** One case → many designers OK; QC2 must stay a single person. */
export const singleEmployeeName = (value?: string | null): string =>
  splitEmployeeNames(value)[0] || "";

export const employeeNameListIncludes = (
  list?: string | null,
  name?: string | null,
): boolean => {
  const target = String(name || "").trim().toLowerCase();
  if (!target) return false;
  return splitEmployeeNames(list).some((n) => n.toLowerCase() === target);
};

export type AllocationInvolvementFields = {
  allocated_Designer?: string | null;
  allocated_Captain?: string | null;
  allocated_captain?: string | null;
  QC1?: string | null;
  QC2?: string | null;
  Designed?: string | null;
};

/** True if this employee is designer, captain, QC1, QC2, or Designed on the case. */
export const isEmployeeInvolvedInCase = (
  row: AllocationInvolvementFields | null | undefined,
  empName?: string | null,
): boolean => {
  if (!row) return false;
  const name = String(empName || "").trim();
  if (!name) return false;
  return (
    employeeNameListIncludes(row.allocated_Designer, name) ||
    employeeNameListIncludes(row.allocated_Captain ?? row.allocated_captain, name) ||
    employeeNameListIncludes(row.QC1, name) ||
    employeeNameListIncludes(row.QC2, name) ||
    employeeNameListIncludes(row.Designed, name)
  );
};
